// Copyright (c) 2016 Deere & Company

import RgaBOReport from '../../../rga/reports/state-connector';

export default {
    component: RgaBOReport,
    name: 'Additional Data BO Reports',
    path: 'bo-report'
};



// WEBPACK FOOTER //
// ./src/routes/rga/reports/rga-bo-reports.js